export default __webpack_public_path__ + "static/media/Green_1.7017d637.svg";